
export class SubmitFundRangeSurveyCommand {
  constructor(public surveyId: string, public rowVersion: string) { }
}
